export class TextModel {
  textId: string;
  text: string;
  lang: string;
}
